<template>
  <div class="footer">
      <div class="footer-mid">
        <div class="container">
          <div class="footer-menu-section">
            <div class="footer-info">
              <div class="footer-info--branding">
                <img src="https://s2026.siggraph.org/wp-content/themes/siggraph2026/assets/images/logo-footer.png"
                  alt="">
              </div>
            </div>
            <div class="footer-menus">
              <div class="footer-menus--row">
                <div class="footer-menu-col menu-col-1">
                  <p class="fmc-title">Get in Touch</p>
                  <ul id="menu-get-in-touch" class="menu">
                    <li class="menu-item"><a href="mailto:sv-s2026@siggraph.org">Contact Us</a></li>
                    <li class="menu-item"><a href="http://eepurl.com/i_uiZY">Join 2026 Mailing List</a></li>
                  </ul>
                </div>
                <div class="footer-menu-col menu-col-2">
                  <p class="fmc-title">ACM Policies &amp; Blog</p>
                  <ul id="menu-acm-policies-blog" class="menu">
                    <li class="menu-item"><a target="_blank" rel="noopener"
                        href="https://www.acm.org/special-interest-groups/volunteer-resources/officers-manual/policy-against-discrimination-and-harassment">Anti-Harassment</a>
                    </li>
                    <li class="menu-item"><a target="_blank" rel="noopener"
                        href="https://www.acm.org/about-acm/privacy-policy">ACM Privacy Policy</a></li>
                    <li class="menu-item"><a href="https://blog.siggraph.org/">ACM SIGGRAPH Blog</a></li>
                  </ul>
                </div>
                <div class="footer-menu-col menu-col-3">
                  <p class="fmc-title">#SIGGRAPH2026 #ProudtobeSV</p>
                  <ul id="menu-siggraph2026" class="menu">
                    <li class="menu-item">
                      <a href="https://s2026.siggraph.org/news-events/">News &#038; Events</a>
                    </li>
                  </ul>
                  <div class="footer-social">
                    <a href="https://www.facebook.com/SIGGRAPHStudentVolunteers" target="_blank"><i
                        class="fab fa-facebook-f"></i><span class="sr-only">Facebook</span></a>
                    <a href="https://instagram.com/siggraphsv/" target="_blank"><i class="fab fa-instagram"></i><span
                        class="sr-only">Instagram</span></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="footer-copyright font-size-small">
              <p class="footer-copyright-rights">&copy; 2026 SIGGRAPH. All rights reserved.</p>
              <p class="footer-copyright-text">The 52nd International Conference & Exhibition On Computer Graphics &
                Interactive Techniques</p>
          </div>
        </div>
      </div>
    </div>
</template>

<script>

export default {
  name: 'Footer',
  data () {
    return {}
  }
}
</script>

<style lang="scss">
  @import '~@fortawesome/fontawesome-free/css/all.css';
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue